<div class="not-found-container">
  <mat-card class="not-found-card">
    <mat-card-content>
      <div class="error-code">404</div>
      
      <div class="icon-wrapper">
        <mat-icon class="error-icon">search_off</mat-icon>
      </div>
      
      <h1 class="title">Page Not Found</h1>
      
      <p class="message">
        The page you're looking for doesn't exist or has been moved.
      </p>

      <div class="actions">
        <a mat-raised-button color="primary" routerLink="/">
          <mat-icon>home</mat-icon>
          Go to Home
        </a>
      </div>
    </mat-card-content>
  </mat-card>
</div>

